import React from 'react';
import i18n from '../../../../../../i18n';
import { drillChartColor, drillRankColor } from './colors';

export type LegendItem = {
  name: string;
  color?: string;
  detail?: string;
  /** Signed period-to-period delta, e.g. "−3.7%". */
  delta?: string;
  deltaTitle?: string;
  /** A dashed line swatch for reference marks (baseline) instead of a dot. */
  swatch?: 'dot' | 'dash';
};

/** Same tint DrillBarChart uses for its compare-period bars. */
export const DRILL_COMPARE_FILL = 'color-mix(in srgb, var(--ink-3) 28%, transparent)';

/** "This period" / compare-period key for bar tiles that draw both. */
export function compareLegendItems(compareLabel?: string): LegendItem[] {
  return [
    { name: i18n.t('performance:drillUi.thisPeriod'), color: drillRankColor(0) },
    {
      name: compareLabel ?? i18n.t('performance:drillUi.compare'),
      color: DRILL_COMPARE_FILL,
    },
  ];
}

/** Compact color key for donut / multi-series tiles. */
export function DrillChartLegend({
  items,
  dense = false,
}: {
  items: LegendItem[];
  dense?: boolean;
}) {
  if (!items.length) return null;
  return (
    <ul
      className={`ddrill-legend${dense ? ' is-dense' : ''}`}
      aria-label={i18n.t('performance:drillUi.chartLegend')}
    >
      {items.map((item, i) => (
        <li className="ddrill-legend-item" key={`${item.name}-${i}`}>
          <span
            className={`ddrill-legend-dot${item.swatch === 'dash' ? ' is-dash' : ''}`}
            style={
              item.swatch === 'dash'
                ? undefined
                : { background: item.color ?? drillChartColor(i) }
            }
            aria-hidden
          />
          <span className="ddrill-legend-name">{item.name}</span>
          {item.detail ? (
            <span className="ddrill-legend-detail">{item.detail}</span>
          ) : null}
          {item.delta ? (
            <span className="ddrill-legend-delta" title={item.deltaTitle}>
              {item.delta}
            </span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
